import { createStore, applyMiddleware } from "redux";
import thunk from "redux-thunk";

import rootReducer from "./common/reducers/rootReducer";

// use applyMiddleware to add the thunk middleware to the store
const store = createStore(rootReducer, applyMiddleware(thunk));

export default store;
